import { requestV1 } from 'apis/base'

export interface DashBoardV1 {
  total_sales: number
  total_pending_sales: number
  current_month_sales: number
  current_month_plan_sales: number
  current_month_shop_sales: number
  current_month_lottery_sales: number
  deposit: number
  next_transfer_fee: number
  member_count: number
  /** @deprecated バックエンド廃止。current_month_plan_sales を使用 */
  door_price?: number
}

export const getDashboardV1 = async (doorId?: string) => {
  let path = '/me/door/dashboard'
  if(doorId !== undefined) path += `?door_id=${doorId}`
  return await requestV1<DashBoardV1>('get', path)
}
export interface PaymentMonthlySumItemV1 {
  date: string
  price: number
  plan_price: number
  shop_price: number
  lottery_price: number
}

export interface PaymentMonthlySumV1 {
  payment_monthly_sum: PaymentMonthlySumItemV1[]
}
export const getPaymentMonthlySumV1 = async (doorId?: string) => {
  let path = '/me/door/payment_monthly_sum'
  if(doorId !== undefined) path += `?door_id=${doorId}`
  return await requestV1<PaymentMonthlySumV1>('get', path)
}
